
<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">仓库详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="仓库名称" prop="WarehouseName" style="display:inline-block;">
          <el-input v-model="ruleForm.WarehouseName" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="Contact" style="display:inline-block;">
          <el-input v-model="ruleForm.Contact" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="移动电话" prop="Phone" style="display:inline-block;">
          <el-input v-model="ruleForm.Phone" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="物资所属企业" prop="OrgId" style="display:inline-block;">
          <el-input v-model="ruleForm.OrgId" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="仓库面积" prop="Area" style="display:inline-block;">
          <el-input v-model="ruleForm.Area" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="仓库地址" prop="Address" style="display:inline-block;">
          <el-input v-model="ruleForm.Address" style="width:118rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="Longitude" style="display:inline-block;">
          <el-input v-model="ruleForm.Longitude" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="Latitude" style="display:inline-block;">
          <el-input v-model="ruleForm.Latitude" style="width:45rem;" v-bind:disabled="IsEdit"></el-input>
          <ZjLngLatSelect
            :point_lat="ruleForm.Latitude"
            :point_lng="ruleForm.Longitude"
            @onGotLngLat="onGotLngLat"
            :disabled="IsEdit"
            title="地图定位"
            style="margin-left:0.8rem;"
          ></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="备注" prop="Remark" style="display:inline-block;">
          <el-input
            type="textarea"
            style="width:118rem;"
            v-model="ruleForm.Remark"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
      </el-form></div>
    </zj-layout-main>
    <zj-layout-footer>
      <div class="right" style="width:134rem; text-align:center;margin:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm({})" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
  
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ZjMaterialWarehouseinfo",
  controller: "UI",
  action: "MaterialWarehouseinfo",
  props: {
    query: {
      type: String,
      obj: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      ruleForm: {
        WarehouseName: "",
        Contact: "",
        Phone: "",
        OrgId: "",
        Area: null,
        Address: "",
        Longitude: "",
        Latitude: "",
        Remark: ""
      },
      rules: {
        WarehouseName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
          { min: 1, max: 15, message: "长度在 1 到 15 个字符", trigger: "blur" }
        ],
        Address: [
          { required: true, message: "请选择仓库地址", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        Longitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        Latitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.search();
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          WarehouseName: "",
          Contact: "",
          Phone: "",
          OrgId: "",
          Area: null,
          Address: "",
          Longitude: "",
          Latitude: "",
          Remark: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat;
      this.ruleForm.Longitude = obj.lng;
    },
    search() {
      let WarehouseId = this.query.obj;
      if (WarehouseId != null && WarehouseId != "") {
        let searchInfo = {
          WarehouseId: WarehouseId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        this.loading = true;
        this.loadingText = '加载中...';
        new MyApis.MaterialWareHouseApi()
          .GetItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            //console.log(r);
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    //返回按钮
    onBack() {
      this.gotoupper();
      //this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm(obj) {
      this.ruleForm = obj;
      this.query.obj = null;
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
      this.ruleForm.Longitude = parseFloat(this.ruleForm.Longitude);
      this.ruleForm.Latitude = parseFloat(this.ruleForm.Latitude);
      if (this.query.obj == null || this.query.obj == "") {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.MaterialWareHouseApi()
          .AddItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "物资仓库保存";
            this.logInfo.LogMessage = r ? "物资仓库保存成功" : "物资仓库保存失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "物资仓库详情页面";
            this.addOperationLog();
            this.gotoupper();
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.MaterialWareHouseApi()
          .UpdateItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "物资仓库修改";
            this.logInfo.LogMessage = r ? "物资仓库修改成功" : "物资仓库修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "物资仓库详情页面";
            this.addOperationLog();
            this.gotoupper();
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
        }
        else {
          console.error("error submit!!");
          return false;
        }
      })
      //this.$router.go(-1); //返回上一层
    },
    gotoupper() {
      this.$router
        .push({
          path: "/plugin/emergency/ui/MaterialWarehouselist",
          // name: 'mallList',
          query: {}
        })
        .catch(() => {});
    }
  }
};
</script>